import Vue, { PluginObject } from 'vue';
import { Dictionary } from 'vue-router/types/router';
import { logger } from '@/util/logger';

type work = (() => Promise<any> | void) | Promise<any> | void;
type namedWork = (name: string, arg: work) => Promise<any>;
type annoWork = (arg: work) => Promise<any>;

declare module 'vue/types/vue' {
  interface Vue {
    $workers: Dictionary<Promise<any>>;

    $doWork: namedWork & annoWork;
  }
}

export default {
  install(vue) {
    vue.mixin({
      data() {
        return {
          $workers: {},
        };
      },

      computed: {
        $isBusy() {
          const k = Object.keys(this.$data.$workers).length > 0;
          logger.debug('is busy', k, this.$data.$workers);

          return k;
        },
      },

      methods: {
        async $doWork(arg1: string | work, arg2?: work): Promise<any> {
          const name: string = (typeof arg1 === 'string' && arg1) || 'work';
          const func = (typeof arg1 !== 'string' && arg1) || arg2;

          if (!func || typeof func !== 'function') {
            throw new Error('invalid work function provided');
          }
          const workers: Dictionary<Promise<any>> = this.$data.$workers;
          let p: Promise<any> = workers[name];
          if (p) {
            logger.debug('already working, returning false');
            return false;
          }
          if (typeof func === 'function') {
            const r = func();
            if (!r) {
              p = Promise.resolve();
            } else {
              p = r;
            }
          } else {
            p = func;
          }
          Vue.set(workers, name, p);

          p.finally(() => Vue.delete(workers, name));
        },
      },
    });
  },
} as PluginObject<any>;
